import { DatePeriod } from "../models/dates/datePeriod";
import { KeyValuePair } from "../models/common/keyValuePair";
import { DAYS_OF_THE_WEEK } from "../contants/DAYS_OF_THE_WEEK";

export class DateHelper{
    static getDateString(d: Date): string {
		return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`;
	}

	static getTimeDifferenceInSeconds(startTime: Date, endTime: Date): number {
		return Math.round((endTime.getTime() - startTime.getTime()) / 1000);
	}

	static getDateDifferenceInDays(startTime: Date, endTime: Date): number {
		var _MS_PER_DAY = 1000 * 60 * 60 * 24;

		var utc1 = Date.UTC(startTime.getFullYear(), startTime.getMonth(), startTime.getDate());
		var utc2 = Date.UTC(endTime.getFullYear(), endTime.getMonth(), endTime.getDate());

		return Math.floor((utc2 - utc1) / _MS_PER_DAY);
	}

	static getDateNowString(): string {
		return this.getDateString(new Date());
	}

	//gets the coverage week base from the given date
	//eg. if startDate is 6 or Saturday
	//	  	and date = March 21, 2018 -> this is a Wednesday (getDay=3)
	//        it should get March 10, 2018 - March 16, 2018 -> saturday to friday since this is considered as 1 week
	static getWeeklyPeriod(d: Date, startDay: number = 6): DatePeriod {
		var day = d.getDay();
		if (day != startDay) { //0=sunday, ... , 6=saturday
			let daysToSubtract = day - (startDay - 1);
			daysToSubtract = daysToSubtract < 1 ? daysToSubtract + 6 : daysToSubtract - 1; 
			d.setDate(d.getDate() - daysToSubtract) //set day to startDay
		}

		var datePeriod = new DatePeriod();
		datePeriod.from = this.getDateString(d);

		d.setDate(d.getDate() + 6); //add 6 days to get last day
		datePeriod.to = this.getDateString(d);
		return datePeriod;
	}

	//gets the monthly period based from the given date's MONTH
	//eg. March 15, 2018
	//		returns March 1, 2018 - March 31, 2018
	static getMonthlyPeriod(d: Date): DatePeriod {
		d.setDate(1); //set to first day of the month
		var datePeriod = new DatePeriod();
		datePeriod.from = this.getDateString(d);

		d.setMonth(d.getMonth() + 1);
		d.setDate(d.getDate() - 1);
		datePeriod.to = this.getDateString(d);
		return datePeriod;
	}

	static getDaysLabel(startDay: number): KeyValuePair[]{
		startDay = Number(startDay);
		if(isNaN(startDay)){
			startDay = 6; //SAT in javascript date
		}

		let labels = DAYS_OF_THE_WEEK;
		let isFirstDayMatch = false;
		
		while(!isFirstDayMatch){
			if(labels[0].key == startDay){
				isFirstDayMatch = true;
			}
			else{
				let temp = labels.shift();
				labels.push(temp);
			}
		}

		return labels;
	}

	static getLastSaturday() {
		let d = new Date();
		d.setDate(d.getDate() - (d.getDay() + 1));
		return d;
	}
}


// WEBPACK FOOTER //
// ./src/app/helpers/DateHelper.ts